import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './core/guards/auth-guard';
import { PreloadSelectedModules } from './core/services/preload-selected-modules';
import { BrowserNotSupportedView, HomeView, Login, Logout } from './core/components';

const ROUTES: Routes = [
  { path: '', component: Login, pathMatch: 'full', data: { breadcrumb: '' } },
  { path: 'browser-support', component: BrowserNotSupportedView },

  { path: 'company', loadChildren: () => import('./company/company.module').then(m => m.CompanyModule), data: { preload: true } },
  { path: 'analytics', loadChildren: () => import('./analytics/analytics.module').then(m => m.AnalyticsModule) },
  { path: 'contacts', loadChildren: () => import('./contacts/contacts.module').then(m => m.ContactsModule) },
  { path: 'promotions', loadChildren: () => import('./promotions/promotions.module').then(m => m.PromotionsModule) },
  { path: 'priceinquiry', loadChildren: () => import('./priceinquiry/priceinquiry.module').then(m => m.PriceInquiryModule) },
  { path: 'reports', loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule) },

  { path: 'activities', loadChildren: () => import('./activities/activities.module').then(m => m.ActivitiesModule) },
  { path: 'callreports', loadChildren: () => import('./callreports/callreports.module').then(m => m.CallReportsModule) },
  { path: 'help', loadChildren: () => import('./help/help.module').then(m => m.HelpModule) },
  { path: 'inventory', loadChildren: () => import('./inventory/inventory.module').then(m => m.InventoryModule) },
  { path: 'invoices', loadChildren: () => import('./invoices/invoices.module').then(m => m.InvoicesModule) },
  { path: 'pricerequests', loadChildren: () => import('./pricerequests/pricerequests.module').then(m => m.PriceRequestsModule) },
  { path: 'marketingrequests', loadChildren: () => import('./marketingrequests/marketingrequests.module').then(m => m.MarketingRequestsModule) },
  { path: 'quarterback', loadChildren: () => import('./quarterback/quarterback.module').then(m => m.QuarterbackModule) },
  { path: 'restock', loadChildren: () => import('./restock/restock.module').then(m => m.RestockModule) },
  { path: 'rgas', loadChildren: () => import('./rga/rga.module').then(m => m.RGAModule) },
  { path: 'servicerequests', loadChildren: () => import('./samplerequests/samplerequests.module').then(m => m.SampleRequestsModule) },
  { path: 'security', loadChildren: () => import('./security/security.module').then(m => m.SecurityModule) },
  { path: 'techsupport', loadChildren: () => import('./techsupport/techsupport.module').then(m => m.TechSupportModule) },
  { path: 'utilities', loadChildren: () => import('./utilities/utilities.module').then(m => m.UtilitiesModule) },
  { path: 'weeklyrecaps', loadChildren: () => import('./weeklyrecaps/weeklyrecaps.module').then(m => m.WeeklyRecapsModule) },

  { path: 'logout', component: Logout },
  { path: 'home', component: HomeView, canActivate: [AuthGuard] },
];

export const AppRoutingModule: ModuleWithProviders = RouterModule.forRoot(ROUTES, { preloadingStrategy: PreloadSelectedModules });
